// @flow
import * as React from 'react'
import Scrollchor from 'react-scrollchor'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import * as Waypoint from 'react-waypoint'
import './styles.scss'

type Props = {
  onLeaveHandler: ({
    currentPosition: string,
    previousPosition: string
  }) => void,
  onEnterHandler: ({
    currentPosition: string,
    previousPosition: string
  }) => void,
  menuAttachement: 'fixed' | 'static',
  activeCategory: string
}

const categories = [5, 4, 3]

function trackClicksOnCategoryMenu (categoryClicked) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'Interactions',
    event_action: 'click',
    event_label: `categoryMenu:${categoryClicked}`
  })
}

export function CategoryMenu ({
  onLeaveHandler,
  onEnterHandler,
  menuAttachement,
  activeCategory
}: Props) {
  return (
    <div className={`${menuAttachement} category-menu`}>
      <div className='ui top attached infographic inverted header'>
        <div className='ui container'>Zu den besten Hotels mit …</div>
      </div>
      <Waypoint
        topOffset='0'
        scrollableAncestor={window}
        onLeave={onLeaveHandler}
        onEnter={onEnterHandler}
      />

      <div className={`ui attached inverted menu`}>
        <div className='ui container'>
          {categories.map(number => {
            return (
              <Scrollchor
                afterAnimate={() => {
                  trackClicksOnCategoryMenu(number)
                }}
                key={`cat-${number}`}
                to={`#cat-${number}`}
                animate={{ offset: -47 }}
                className={`${activeCategory === `cat-${number}`
                  ? 'active'
                  : ''} item`}
              >
                {number} Sternen
              </Scrollchor>
            )
          })}
        </div>
      </div>
      <div className='spacer' />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/categoryMenu/component.js